<template>
  <GenericSubView
    :page-heading="translations.transition.manualsPage.manualsHeading"
  >
    <template #transitionProductSearch>
      <slot name="productSearch" />
    </template>

    <template #supplemental>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-html="translations.transition.manualsPage.supplementalManualsInfo" />
    </template>
  </GenericSubView>
</template>

<script>
import GenericSubView from './generic/index.vue';
import TranslationsMixin from '../../../mixins/translations';

export default {
  name: 'ManualsSubView',
  components: {
    GenericSubView,
  },
  mixins: [TranslationsMixin],
};
</script>
